import type { FC, ReactNode } from "react";

export interface BadgeProps {
	variant?: "default" | "success" | "warning" | "error" | "info";
	size?: "sm" | "md";
	children: ReactNode;
	className?: string;
}

const variantClasses: Record<string, string> = {
	default: "bg-surface-2 text-content ring-line",
	success: "bg-success-soft text-success ring-success/20",
	warning: "bg-warning-soft text-warning ring-warning/20",
	error: "bg-danger-soft text-danger ring-danger/20",
	info: "bg-primary-soft text-primary ring-primary/20",
};

const sizeClasses: Record<string, string> = {
	sm: "px-1.5 py-0.5 text-xs",
	md: "px-2 py-1 text-xs",
};

export const Badge: FC<BadgeProps> = ({
	variant = "default",
	size = "md",
	children,
	className = "",
}) => {
	return (
		<span
			className={`inline-flex items-center rounded-md font-medium ring-1 ring-inset ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
		>
			{children}
		</span>
	);
};
